export default __webpack_public_path__ + "static/media/Path3406.72db1145.svg";